import { render } from "./VSnackbar.vue?vue&type=template&id=15a7fb28&ts=true"
import script from "./VSnackbar.vue?vue&type=script&lang=ts"
export * from "./VSnackbar.vue?vue&type=script&lang=ts"

import "./VSnackbar.vue?vue&type=style&index=0&id=15a7fb28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__